import ThemePreview from 'src/views/SystemSettings/ThemeEditor/ThemePreview';
import WorkTray from './WorkTray';
import BadgeList from '../customFields/BadgeList';
import FormVersionStatusPill from '../customFields/FormVersionStatusPill';

const WORKPAGE_COMPONENTS = {
  ThemePreview: ThemePreview,
  worktray: WorkTray,
  BadgeList: BadgeList,
  FormVersionStatusPill: FormVersionStatusPill,
};

export default WORKPAGE_COMPONENTS;
